module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gmiYI"))).then(() => parcelRequire('hEqeo'));